import { render, staticRenderFns } from "./DetailsEditPerson.vue?vue&type=template&id=5f69516b&"
import script from "./DetailsEditPerson.vue?vue&type=script&lang=js&"
export * from "./DetailsEditPerson.vue?vue&type=script&lang=js&"
import style0 from "./DetailsEditPerson.vue?vue&type=style&index=0&id=5f69516b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports